module.exports = __webpack_public_path__ + "static/media/iconAdoptionRequest.042f5101.svg";